import { IOffer } from '../../../types/offerData';

/**
 * Формирует заголовок блока по категории оффера
 *
 * @param category - категория оффера
 */
export const getTitleByOfferCategory = (category: IOffer['category']) => {
  let objectType;

  switch (category) {
    case 'houseSale':
    case 'cottageSale':
    case 'houseShareSale':
      objectType = 'Дом';
      break;
    case 'landSale':
      objectType = 'Участок';
      break;
    case 'townhouseSale':
      objectType = 'Таунхаус';
      break;
    default:
      objectType = 'Объект';
  }

  return `${objectType} на генплане посёлка`;
};
